import {Mensagem, Resposta} from '../model/sgsia/paginacao-sgsia';
import {EnderecoSisbi} from '../model/sisbi/endereco-sisbi';
import {EnderecoCorporativo} from '../model/corporativo/endereco-corporativo';

/**
 * Classe que agrupas todas as funcionalidades de interesse comum da aplicação
 */
export class Util {

    static isEmpty(valor: any): boolean {
        return valor === undefined || valor === null || valor === '' || valor.length === 0 || valor.toString().trim().length === 0;

    }

    static onlyDigits(valor: string): string {
        return valor ? valor.replace(/\D/g, '') : '';
    }

    static descricaoEndereco(endereco: EnderecoSisbi | EnderecoCorporativo): string {
        if (endereco.logradouro) {
            const cep = endereco.logradouro.nrCep;
            const uf = endereco.logradouro.sgUf;
            const municipio = endereco.logradouro.municipio ? endereco.logradouro.municipio.nmMunicipio : '';
            const dsLogradouro = (!!endereco.logradouro.nmLogradouroComplemento && !!endereco.logradouro.nmLogradouroComplemento.trim())
                ? endereco.logradouro.nmLogradouroComplemento.trim() : endereco.logradouro.nmLogradouro;
            return `CEP: ${cep}
            - ${dsLogradouro}, ${endereco.nrComplemento || ''}, ${endereco.txComplementoEndereco || ''}
            - ${municipio} - ${uf}`;

            // return `CEP: ${cep} |
            // Município: ${municipio} - ${uf} |
            // Logradouro: ${dsLogradouro} |
            // Nº: ${endereco.nrComplemento || ''} |
            // Complemento: ${endereco.txComplementoEndereco || ''}`;
        }
        return 'Endereço Inválido: ' + endereco.idEndereco;
    }

    /**
     * Recupera as mensagens da resposta
     */
    static getMensagensResposta(resposta: Resposta<any> | any): Mensagem[] {
        if (!!resposta) {
            const transacao = (resposta.error && resposta.error.transacao) ? resposta.error.transacao : resposta.transacao;
            if (!!transacao && !!transacao.listaMensagens) {
                return transacao.listaMensagens;
            } else {
                console.log('Erro não mapeado...', resposta);

                if (!!resposta.error && !!resposta.error.message) {
                    return [{tipo: 'E', codigo: '0.0000', descricao: resposta.error.message}];
                } else if (!!resposta.message) {
                    return [{tipo: 'E', codigo: '0.0000', descricao: resposta.message}];
                } else {
                    return [{tipo: 'E', codigo: '0.0000', descricao: 'Ocorreu um erro desconhecido...'}];
                }
            }
        }
        return [];
    }

}
